import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { Card } from './Card';

export function AriaBalanceCard() {
  const { user, isAuthenticated } = useAuth0();
  const enabled = import.meta.env.VITE_ARIA_ACCOUNTING_PREVIEW === 'true';
  const query = useQuery({
    queryKey: ['aria-balance', user?.sub],
    queryFn: () => apiClient.getAriaBalance(),
    enabled: enabled && isAuthenticated && !!user?.sub,
    staleTime: 15_000,
    refetchInterval: 30_000,
    retry: 1,
  });
  if (!enabled || !isAuthenticated) return null;
  const b = query.data?.balance;
  const reset = b ? new Date(b.resetsUtc) : null;
  return (
    <Card title="ARIA allowances" action={<button type="button" className="text-sm text-purple-300 px-4" onClick={() => void query.refetch()} disabled={query.isFetching}>Refresh</button>}>
      {query.isError ? <p role="status" className="text-gray-300">Your allowances could not be refreshed. Please try again.</p>
        : !b ? <p role="status" className="text-gray-400">Loading your allowances…</p>
        : <div className="space-y-3 text-sm text-gray-300">
          <p><strong className="text-white">{b.monthOptionalConsumed}</strong> optional updates used this month
            {b.rights.optionalPerMonth === null ? ' · No monthly limit on your current purchased term.' : ` of ${b.rights.optionalPerMonth}.`}
            {b.monthOptionalReserved > 0 && ` ${b.monthOptionalReserved} in progress.`}</p>
          <p>Each recording session includes up to {b.rights.slots} combined watches and timers, and {b.rights.optionalPerSession} optional updates.</p>
          <p>Ordinary questions and built-in MIL/new-code alerts do not use these optional-update allowances.</p>
          {b.rights.completedResearchPerMonth > 0 && <p>
            Research reports: {b.monthResearchCompleted} of {b.rights.completedResearchPerMonth} completed this month.
            {b.monthResearchReserved > 0 && ` ${b.monthResearchReserved} in progress.`}
            {!b.researchAvailable && ' New research is currently unavailable.'}
          </p>}
          {reset && !Number.isNaN(reset.getTime()) && <p className="text-gray-400">Monthly allowances reset {reset.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' })} ({Intl.DateTimeFormat().resolvedOptions().timeZone}).</p>}
        </div>}
    </Card>
  );
}
